import React from 'react'

import type { IFieldLayoutProps } from 'components/formKit/types'
import { testProps } from 'utils/test/qaData'

import * as s from './FieldBaseError.module.scss'

const FieldBaseError: React.FC<Omit<IFieldLayoutProps, 'children'>> = ({ error, name }) => {
  if (!error || typeof error !== 'string') {
    return null
  }

  return (
    <div className={s.root} {...testProps({ el: 'error', name, label: error })}>
      {error}
    </div>
  )
}

export default React.memo(FieldBaseError) as typeof FieldBaseError
